import React from 'react';
import Button from '../../../common/Buttons/Button';
import ReadAloudToggleButton from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/ReadAloud/components/ReadAloudTogglePlayButton';
import IconButton from '../../../common/Buttons/IconButton';
import { useHTMLRenderEngine } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@legacy/HTMLRenderEngine';
import { useReadBookAudio } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/ReadBookAudioProvider';
import { faPlay, faStop } from '@fortawesome/free-solid-svg-icons';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { ReadingType } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/types';
import makeStyles from '@mui/styles/makeStyles';

const t = (key: string) => translate('letterBooks', key);

type Props = {
  readingType: ReadingType;
  onChange: (readingType: ReadingType) => void;
};

const ToggleReadingType: React.FC<Props> = ({ readingType, onChange }) => {
  const classes = styles();
  const [{ shouldPlay }, { togglePlay }] = useHTMLRenderEngine();
  const [, { pauseSound }] = useReadBookAudio();

  const handleReadAloudClick = () => {
    pauseSound();
    onChange(ReadingType.ReadAloud);
  };

  const handleReadAloudStop = () => {
    if (shouldPlay) {
      pauseSound();
      togglePlay();
    }
    onChange(ReadingType.ReadStory);
  };

  const renderReadStoryControls = () => (
    <Button
      onClick={handleReadAloudClick}
      startIcon={faPlay}
      className={classes.button}
      color="secondary"
    >
      {t('readAloud')}
    </Button>
  );

  const renderReadAloudControls = () => (
    <>
      <ReadAloudToggleButton
        component={Button}
        color="secondary"
        style={{ fontSize: '1rem' }}
        iconProps={{
          color: 'white',
        }}
      />
      <IconButton
        onClick={handleReadAloudStop}
        icon={faStop}
        size="small"
        color="secondary"
        iconProps={{ size: 'sm' }}
      />
    </>
  );

  const renderControls: { [key in ReadingType]: () => JSX.Element } = {
    [ReadingType.ReadStory]: renderReadStoryControls,
    [ReadingType.ReadAloud]: renderReadAloudControls,
  };

  return renderControls[readingType]();
};

const styles = makeStyles((theme: any) => ({
  button: {
    width: theme.typography.pxToRem(296),
    maxHeight: theme.typography.pxToRem(72),
  },
}));

export default ToggleReadingType;
